import { render, staticRenderFns } from "./LaravelVuePagination.vue?vue&type=template&id=49d1861c"
import script from "./LaravelVuePagination.vue?vue&type=script&lang=js"
export * from "./LaravelVuePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/myc-feat.learningsystem.de/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d1861c')) {
      api.createRecord('49d1861c', component.options)
    } else {
      api.reload('49d1861c', component.options)
    }
    module.hot.accept("./LaravelVuePagination.vue?vue&type=template&id=49d1861c", function () {
      api.rerender('49d1861c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/LaravelVuePagination.vue"
export default component.exports